import "./widget.scss";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { useEffect } from "react";

const BigRoom = ({ type }) => {
  let data;

  //temporary
  const amount = 100;
  

  switch (type) {
    
    // case "order":
    //   data = {
    //     title: "ORDERS",
    //     isMoney: false,
    //     link: "View all orders",
    //     icon: (
    //       <ShoppingCartOutlinedIcon
    //         className="icon"
    //         style={{
    //           backgroundColor: "rgba(218, 165, 32, 0.2)",
    //           color: "goldenrod",
    //         }}
    //       />
    //     ),
    //   };
    //   break;
    case "bigroom":
      data = {
        title: "Big Room Booking",
        isMoney: true,
        // link: "View customers",
        icon: (
          <MonetizationOnOutlinedIcon
            className="icon"
            style={{ backgroundColor: "rgba(0, 128, 0, 0.2)", color: "green" }}
          />
        ),
      };
      break;
    default:
      break;
  }

  useEffect(() => {
    const fectchData = async() =>{
      const today = new Date() 
    }
    fectchData()
    
  }, [])
   

  return (
    <div className="widget">
      <div className="left">
        <span className="title">{data.title}</span>
        <span className="counter">
          {data.isMoney && "$"} {amount}
        </span>
        <span className="link">{data.link}</span>
      </div>
      <div className="right">
        {/* <div className="percentage positive">
          <KeyboardArrowUpIcon />
          {diff} %
        </div> */}
        {data.icon}
      </div>
    </div>
  );
};

export default BigRoom;
